import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRewardList as rewardList,
  optInReward,
  optOutReward,
  getUserRewards as getRewards,
} from "../../services/rewards";

export const getRewardList = createAsyncThunk(
  "reward/getRewardList",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await rewardList();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const activateReward = createAsyncThunk(
  "reward/activateReward",
  async (obj, { rejectWithValue }) => {
    try {
      const { planId, token } = obj;
      const response = await optInReward(planId, token);
      return response;
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error.response)));
    }
  }
);

export const deactivateReward = createAsyncThunk(
  "reward/deactivateReward",
  async (obj, { rejectWithValue }) => {
    try {
      const { planId, token } = obj;
      const response = await optOutReward(planId, token);
      return response;
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error.response)));
    }
  }
);

export const getUserRewards = createAsyncThunk(
  "reward/getUserRewards",
  async (obj, { rejectWithValue }) => {
    try {
      const { token } = obj;
      const response = await getRewards(token);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  list: {
    data: [],
    error: null,
    status: null,
  },
  optIn: {
    data: null,
    error: null,
    status: null,
  },
  optOut: {
    data: null,
    error: null,
    status: null,
  },
  userRewards: {
    data: [],
    error: null,
    status: null,
  },
};

export const rewardSlice = createSlice({
  name: "reward",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getRewardList.pending, (state, action) => {
        state.list = { ...state.list, status: "loading" };
      })
      .addCase(getRewardList.fulfilled, (state, action) => {
        state.list = {
          ...state.list,
          status: "succeeded",
          data: action.payload.response,
          error: null,
        };
      })
      .addCase(getRewardList.rejected, (state, action) => {
        state.list = {
          ...state.list,
          status: "failed",
          error: action.payload.error,
          data: [],
        };
      })
      .addCase(activateReward.pending, (state, action) => {
        state.optIn = { ...state.optIn, status: "loading" };
      })
      .addCase(activateReward.fulfilled, (state, action) => {
        state.optIn = {
          ...state.optIn,
          status: "succeeded",
          data: action.payload.response,
          error: null,
        };
      })
      .addCase(activateReward.rejected, (state, action) => {
        state.optIn = {
          ...state.optIn,
          status: "failed",
          error: action.payload,
          data: [],
        };
      })
      .addCase(deactivateReward.pending, (state, action) => {
        state.optOut = { ...state.optOut, status: "loading" };
      })
      .addCase(deactivateReward.fulfilled, (state, action) => {
        state.optOut = {
          ...state.optOut,
          status: "succeeded",
          data: action.payload.response,
          error: null,
        };
      })
      .addCase(deactivateReward.rejected, (state, action) => {
        state.optOut = {
          ...state.optOut,
          status: "failed",
          error: action.payload,
          data: [],
        };
      })
      .addCase(getUserRewards.pending, (state, action) => {
        state.userRewards = { ...state.userRewards, status: "loading" };
      })
      .addCase(getUserRewards.fulfilled, (state, action) => {
        state.userRewards = {
          ...state.userRewards,
          status: "succeeded",
          data: action.payload.response,
          error: null,
        };
      })
      .addCase(getUserRewards.rejected, (state, action) => {
        state.userRewards = {
          ...state.userRewards,
          status: "failed",
          error: action.payload.error,
          data: [],
        };
      });
  },
});

export default rewardSlice.reducer;
